import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const SecurityIcon: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg
      fill="none"
      height="20"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.742 1.859L4.583 3.417c-.958.358-1.742 1.492-1.742 2.517v6.192c0 .983.65 2.275 1.442 2.867l3.583 2.675c1.175.883 3.108.883 4.283 0l3.583-2.675c.792-.592 1.442-1.883 1.442-2.867V5.934c0-1.025-.783-2.158-1.742-2.517l-4.158-1.558c-.708-.258-1.842-.258-2.533 0z" />
      <path d="M10 9.1h-.108c-.783-.025-1.408-.675-1.408-1.467A1.47 1.47 0 0 1 9.95 6.167a1.47 1.47 0 0 1 1.467 1.467A1.47 1.47 0 0 1 10 9.1zm-1.658 2.334c-.8.533-.8 1.408 0 1.942.908.608 2.4.608 3.308 0 .8-.533.8-1.408 0-1.942-.9-.608-2.392-.608-3.308 0z" />
    </svg>
  </SVGIcon>
);

export default SecurityIcon;
